/** Socket.IO event names shared by gateway and client. */
export const SOCKET_EVENT = {
  ERROR: "error",
  NEW_MESSAGE: "new-message",
  MESSAGE_UPDATED: "message-updated",
  TENANT_PRESENCE: "tenant-presence",
  TENANT_PRESENCE_SNAPSHOT: "tenant-presence-snapshot",
  PRESENCE: "presence",
  PRESENCE_SNAPSHOT: "presence-snapshot",
  TYPING: "typing",
  ROOM_READ: "room-read",
  JOINED_ROOM: "joined-room",
  LEFT_ROOM: "left-room",
  JOIN_ROOM: "join-room",
  LEAVE_ROOM: "leave-room",
  CALL_INVITE: "call-invite",
  CALL_ACCEPTED: "call-accepted",
  CALL_DECLINED: "call-declined",
  CALL_ENDED: "call-ended",
} as const;

export type SocketEvent = (typeof SOCKET_EVENT)[keyof typeof SOCKET_EVENT];

export type PresenceEvent = {
  userId: string;
  online: boolean;
};

export type TypingEvent = {
  roomId: string;
  userId: string;
  isTyping: boolean;
};

export type RoomReadEvent = {
  roomId: string;
  userId: string;
  lastReadAt: string;
  lastReadMessageId: string | null;
};

export type OnlineUserIdsSnapshot = {
  onlineUserIds: string[];
};

export type RoomIdPayload = {
  roomId: string;
};

export type SocketErrorPayload = {
  message: string;
};

export type CallTypeWire = "audio" | "video";

export type CallInviteEvent = {
  callId: string;
  roomId: string;
  type: CallTypeWire;
  createdByUserId: string;
  livekitRoomName: string;
};

export type CallAcceptedEvent = {
  callId: string;
  roomId: string;
  userId: string;
};

export type CallDeclinedEvent = {
  callId: string;
  roomId: string;
  userId: string;
};

export type CallEndedEvent = {
  callId: string;
  roomId: string;
  reason?: string;
};
